var kt = Object.defineProperty;
var Nt = (n, t, e) => t in n ? kt(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var X = (n, t, e) => Nt(n, typeof t != "symbol" ? t + "" : t, e);
import * as f from "react";
import H, { Children as jt, isValidElement as q, cloneElement as Z } from "react";
import { _ as $t, c as x, g as Ft } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { j } from "./jsx-runtime-3tyXYecC.mjs";
import { g as dt } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { k as et } from "./emotion-react.browser.esm-BdEGsKDn.mjs";
import { s as nt, u as ht, c as Ut } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { _ as vt, a as zt } from "./inheritsLoose-OI-DR2K6.mjs";
import { _ as Ot } from "./assertThisInitialized-lz6cHcRv.mjs";
import { T as lt } from "./TransitionGroupContext-gTqf7voF.mjs";
import { u as ct } from "./useForkRef-C_4o__cU.mjs";
import { u as G } from "./useEventCallback-B4gn-DZo.mjs";
import { i as pt } from "./isFocusVisible-CLflI_-N.mjs";
const ft = {};
function mt(n, t) {
  const e = f.useRef(ft);
  return e.current === ft && (e.current = n(t)), e;
}
const Yt = [];
function At(n) {
  f.useEffect(n, Yt);
}
class ot {
  constructor() {
    X(this, "currentId", null);
    X(this, "clear", () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    });
    X(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new ot();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, e) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, e();
    }, t);
  }
}
function Xt() {
  const n = mt(ot.create).current;
  return At(n.disposeEffect), n;
}
function it(n, t) {
  var e = function(i) {
    return t && q(i) ? t(i) : i;
  }, a = /* @__PURE__ */ Object.create(null);
  return n && jt.map(n, function(o) {
    return o;
  }).forEach(function(o) {
    a[o.key] = e(o);
  }), a;
}
function _t(n, t) {
  n = n || {}, t = t || {};
  function e(d) {
    return d in t ? t[d] : n[d];
  }
  var a = /* @__PURE__ */ Object.create(null), o = [];
  for (var i in n)
    i in t ? o.length && (a[i] = o, o = []) : o.push(i);
  var r, c = {};
  for (var u in t) {
    if (a[u])
      for (r = 0; r < a[u].length; r++) {
        var p = a[u][r];
        c[a[u][r]] = e(p);
      }
    c[u] = e(u);
  }
  for (r = 0; r < o.length; r++)
    c[o[r]] = e(o[r]);
  return c;
}
function N(n, t, e) {
  return e[t] != null ? e[t] : n.props[t];
}
function Kt(n, t) {
  return it(n.children, function(e) {
    return Z(e, {
      onExited: t.bind(null, e),
      in: !0,
      appear: N(e, "appear", n),
      enter: N(e, "enter", n),
      exit: N(e, "exit", n)
    });
  });
}
function Wt(n, t, e) {
  var a = it(n.children), o = _t(t, a);
  return Object.keys(o).forEach(function(i) {
    var r = o[i];
    if (q(r)) {
      var c = i in t, u = i in a, p = t[i], d = q(p) && !p.props.in;
      u && (!c || d) ? o[i] = Z(r, {
        onExited: e.bind(null, r),
        in: !0,
        exit: N(r, "exit", n),
        enter: N(r, "enter", n)
      }) : !u && c && !d ? o[i] = Z(r, {
        in: !1
      }) : u && c && q(p) && (o[i] = Z(r, {
        onExited: e.bind(null, r),
        in: p.props.in,
        exit: N(r, "exit", n),
        enter: N(r, "enter", n)
      }));
    }
  }), o;
}
var Ht = Object.values || function(n) {
  return Object.keys(n).map(function(t) {
    return n[t];
  });
}, Gt = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, rt = /* @__PURE__ */ function(n) {
  vt(t, n);
  function t(a, o) {
    var i;
    i = n.call(this, a, o) || this;
    var r = i.handleExited.bind(Ot(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: r,
      firstRender: !0
    }, i;
  }
  var e = t.prototype;
  return e.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, e.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(o, i) {
    var r = i.children, c = i.handleExited, u = i.firstRender;
    return {
      children: u ? Kt(o, c) : Wt(o, r, c),
      firstRender: !1
    };
  }, e.handleExited = function(o, i) {
    var r = it(this.props.children);
    o.key in r || (o.props.onExited && o.props.onExited(i), this.mounted && this.setState(function(c) {
      var u = $t({}, c.children);
      return delete u[o.key], {
        children: u
      };
    }));
  }, e.render = function() {
    var o = this.props, i = o.component, r = o.childFactory, c = zt(o, ["component", "childFactory"]), u = this.state.contextValue, p = Ht(this.state.children).map(r);
    return delete c.appear, delete c.enter, delete c.exit, i === null ? /* @__PURE__ */ H.createElement(lt.Provider, {
      value: u
    }, p) : /* @__PURE__ */ H.createElement(lt.Provider, {
      value: u
    }, /* @__PURE__ */ H.createElement(i, c, p));
  }, t;
}(H.Component);
rt.propTypes = {};
rt.defaultProps = Gt;
class J {
  constructor() {
    X(this, "mountEffect", () => {
      this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
    });
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new J();
  }
  static use() {
    const t = mt(J.create).current, [e, a] = f.useState(!1);
    return t.shouldMount = e, t.setShouldMount = a, f.useEffect(t.mountEffect, [e]), t;
  }
  mount() {
    return this.mounted || (this.mounted = Zt(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  /* Ripple API */
  start(...t) {
    this.mount().then(() => {
      var e;
      return (e = this.ref.current) == null ? void 0 : e.start(...t);
    });
  }
  stop(...t) {
    this.mount().then(() => {
      var e;
      return (e = this.ref.current) == null ? void 0 : e.stop(...t);
    });
  }
  pulsate(...t) {
    this.mount().then(() => {
      var e;
      return (e = this.ref.current) == null ? void 0 : e.pulsate(...t);
    });
  }
}
function qt() {
  return J.use();
}
function Zt() {
  let n, t;
  const e = new Promise((a, o) => {
    n = a, t = o;
  });
  return e.resolve = n, e.reject = t, e;
}
function Jt(n) {
  const {
    className: t,
    classes: e,
    pulsate: a = !1,
    rippleX: o,
    rippleY: i,
    rippleSize: r,
    in: c,
    onExited: u,
    timeout: p
  } = n, [d, M] = f.useState(!1), g = x(t, e.ripple, e.rippleVisible, a && e.ripplePulsate), S = {
    width: r,
    height: r,
    top: -(r / 2) + i,
    left: -(r / 2) + o
  }, h = x(e.child, d && e.childLeaving, a && e.childPulsate);
  return !c && !d && M(!0), f.useEffect(() => {
    if (!c && u != null) {
      const V = setTimeout(u, p);
      return () => {
        clearTimeout(V);
      };
    }
  }, [u, c, p]), /* @__PURE__ */ j.jsx("span", {
    className: g,
    style: S,
    children: /* @__PURE__ */ j.jsx("span", {
      className: h
    })
  });
}
const m = dt("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), tt = 550, Qt = 80, te = et`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, ee = et`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, ne = et`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, oe = nt("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), ie = nt(Jt, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${m.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${te};
    animation-duration: ${tt}ms;
    animation-timing-function: ${({
  theme: n
}) => n.transitions.easing.easeInOut};
  }

  &.${m.ripplePulsate} {
    animation-duration: ${({
  theme: n
}) => n.transitions.duration.shorter}ms;
  }

  & .${m.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${m.childLeaving} {
    opacity: 0;
    animation-name: ${ee};
    animation-duration: ${tt}ms;
    animation-timing-function: ${({
  theme: n
}) => n.transitions.easing.easeInOut};
  }

  & .${m.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${ne};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: n
}) => n.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, re = /* @__PURE__ */ f.forwardRef(function(t, e) {
  const a = ht({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: o = !1,
    classes: i = {},
    className: r,
    ...c
  } = a, [u, p] = f.useState([]), d = f.useRef(0), M = f.useRef(null);
  f.useEffect(() => {
    M.current && (M.current(), M.current = null);
  }, [u]);
  const g = f.useRef(!1), S = Xt(), h = f.useRef(null), V = f.useRef(null), T = f.useCallback((l) => {
    const {
      pulsate: R,
      rippleX: b,
      rippleY: U,
      rippleSize: w,
      cb: v
    } = l;
    p((y) => [...y, /* @__PURE__ */ j.jsx(ie, {
      classes: {
        ripple: x(i.ripple, m.ripple),
        rippleVisible: x(i.rippleVisible, m.rippleVisible),
        ripplePulsate: x(i.ripplePulsate, m.ripplePulsate),
        child: x(i.child, m.child),
        childLeaving: x(i.childLeaving, m.childLeaving),
        childPulsate: x(i.childPulsate, m.childPulsate)
      },
      timeout: tt,
      pulsate: R,
      rippleX: b,
      rippleY: U,
      rippleSize: w
    }, d.current)]), d.current += 1, M.current = v;
  }, [i]), $ = f.useCallback((l = {}, R = {}, b = () => {
  }) => {
    const {
      pulsate: U = !1,
      center: w = o || R.pulsate,
      fakeElement: v = !1
      // For test purposes
    } = R;
    if ((l == null ? void 0 : l.type) === "mousedown" && g.current) {
      g.current = !1;
      return;
    }
    (l == null ? void 0 : l.type) === "touchstart" && (g.current = !0);
    const y = v ? null : V.current, I = y ? y.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let B, C, D;
    if (w || l === void 0 || l.clientX === 0 && l.clientY === 0 || !l.clientX && !l.touches)
      B = Math.round(I.width / 2), C = Math.round(I.height / 2);
    else {
      const {
        clientX: z,
        clientY: L
      } = l.touches && l.touches.length > 0 ? l.touches[0] : l;
      B = Math.round(z - I.left), C = Math.round(L - I.top);
    }
    if (w)
      D = Math.sqrt((2 * I.width ** 2 + I.height ** 2) / 3), D % 2 === 0 && (D += 1);
    else {
      const z = Math.max(Math.abs((y ? y.clientWidth : 0) - B), B) * 2 + 2, L = Math.max(Math.abs((y ? y.clientHeight : 0) - C), C) * 2 + 2;
      D = Math.sqrt(z ** 2 + L ** 2);
    }
    l != null && l.touches ? h.current === null && (h.current = () => {
      T({
        pulsate: U,
        rippleX: B,
        rippleY: C,
        rippleSize: D,
        cb: b
      });
    }, S.start(Qt, () => {
      h.current && (h.current(), h.current = null);
    })) : T({
      pulsate: U,
      rippleX: B,
      rippleY: C,
      rippleSize: D,
      cb: b
    });
  }, [o, T, S]), _ = f.useCallback(() => {
    $({}, {
      pulsate: !0
    });
  }, [$]), F = f.useCallback((l, R) => {
    if (S.clear(), (l == null ? void 0 : l.type) === "touchend" && h.current) {
      h.current(), h.current = null, S.start(0, () => {
        F(l, R);
      });
      return;
    }
    h.current = null, p((b) => b.length > 0 ? b.slice(1) : b), M.current = R;
  }, [S]);
  return f.useImperativeHandle(e, () => ({
    pulsate: _,
    start: $,
    stop: F
  }), [_, $, F]), /* @__PURE__ */ j.jsx(oe, {
    className: x(m.root, i.root, r),
    ref: V,
    ...c,
    children: /* @__PURE__ */ j.jsx(rt, {
      component: null,
      exit: !0,
      children: u
    })
  });
});
function se(n) {
  return Ft("MuiButtonBase", n);
}
const ae = dt("MuiButtonBase", ["root", "disabled", "focusVisible"]), ue = (n) => {
  const {
    disabled: t,
    focusVisible: e,
    focusVisibleClassName: a,
    classes: o
  } = n, r = Ut({
    root: ["root", t && "disabled", e && "focusVisible"]
  }, se, o);
  return e && a && (r.root += ` ${a}`), r;
}, le = nt("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (n, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${ae.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), Ee = /* @__PURE__ */ f.forwardRef(function(t, e) {
  const a = ht({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: o,
    centerRipple: i = !1,
    children: r,
    className: c,
    component: u = "button",
    disabled: p = !1,
    disableRipple: d = !1,
    disableTouchRipple: M = !1,
    focusRipple: g = !1,
    focusVisibleClassName: S,
    LinkComponent: h = "a",
    onBlur: V,
    onClick: T,
    onContextMenu: $,
    onDragLeave: _,
    onFocus: F,
    onFocusVisible: l,
    onKeyDown: R,
    onKeyUp: b,
    onMouseDown: U,
    onMouseLeave: w,
    onMouseUp: v,
    onTouchEnd: y,
    onTouchMove: I,
    onTouchStart: B,
    tabIndex: C = 0,
    TouchRippleProps: D,
    touchRippleRef: z,
    type: L,
    ...O
  } = a, Y = f.useRef(null), E = qt(), gt = ct(E.ref, z), [k, K] = f.useState(!1);
  p && k && K(!1), f.useImperativeHandle(o, () => ({
    focusVisible: () => {
      K(!0), Y.current.focus();
    }
  }), []);
  const bt = E.shouldMount && !d && !p;
  f.useEffect(() => {
    k && g && !d && E.pulsate();
  }, [d, g, k, E]);
  function P(s, at, Lt = M) {
    return G((ut) => (at && at(ut), Lt || E[s](ut), !0));
  }
  const Mt = P("start", U), Rt = P("stop", $), yt = P("stop", _), xt = P("stop", v), Tt = P("stop", (s) => {
    k && s.preventDefault(), w && w(s);
  }), Ct = P("start", B), Et = P("stop", y), Pt = P("stop", I), St = P("stop", (s) => {
    pt(s.target) || K(!1), V && V(s);
  }, !1), It = G((s) => {
    Y.current || (Y.current = s.currentTarget), pt(s.target) && (K(!0), l && l(s)), F && F(s);
  }), Q = () => {
    const s = Y.current;
    return u && u !== "button" && !(s.tagName === "A" && s.href);
  }, Bt = G((s) => {
    g && !s.repeat && k && s.key === " " && E.stop(s, () => {
      E.start(s);
    }), s.target === s.currentTarget && Q() && s.key === " " && s.preventDefault(), R && R(s), s.target === s.currentTarget && Q() && s.key === "Enter" && !p && (s.preventDefault(), T && T(s));
  }), Dt = G((s) => {
    g && s.key === " " && k && !s.defaultPrevented && E.stop(s, () => {
      E.pulsate(s);
    }), b && b(s), T && s.target === s.currentTarget && Q() && s.key === " " && !s.defaultPrevented && T(s);
  });
  let W = u;
  W === "button" && (O.href || O.to) && (W = h);
  const A = {};
  W === "button" ? (A.type = L === void 0 ? "button" : L, A.disabled = p) : (!O.href && !O.to && (A.role = "button"), p && (A["aria-disabled"] = p));
  const Vt = ct(e, Y), st = {
    ...a,
    centerRipple: i,
    component: u,
    disabled: p,
    disableRipple: d,
    disableTouchRipple: M,
    focusRipple: g,
    tabIndex: C,
    focusVisible: k
  }, wt = ue(st);
  return /* @__PURE__ */ j.jsxs(le, {
    as: W,
    className: x(wt.root, c),
    ownerState: st,
    onBlur: St,
    onClick: T,
    onContextMenu: Rt,
    onFocus: It,
    onKeyDown: Bt,
    onKeyUp: Dt,
    onMouseDown: Mt,
    onMouseLeave: Tt,
    onMouseUp: xt,
    onDragLeave: yt,
    onTouchEnd: Et,
    onTouchMove: Pt,
    onTouchStart: Ct,
    ref: Vt,
    tabIndex: p ? -1 : C,
    type: L,
    ...A,
    ...O,
    children: [r, bt ? /* @__PURE__ */ j.jsx(re, {
      ref: gt,
      center: i,
      ...D
    }) : null]
  });
});
export {
  Ee as B,
  rt as T,
  Xt as u
};
//# sourceMappingURL=ButtonBase-BIvHZGlt.mjs.map
